import * as React from 'react';
import { Lock, X } from 'lucide-react';
import './AnalyzeAgainModal.css';
import './BulkCloseConfirmModal.css';

interface BulkCloseConfirmModalProps {
  trackChangesCount: number;
  totalCount: number;
  busy?: boolean;
  busyMessage?: string | null;
  onAcceptAndClose: () => void;
  onCloseWithoutAccept: () => void;
  onCancel: () => void;
}

export const BulkCloseConfirmModal: React.FC<BulkCloseConfirmModalProps> = ({
  trackChangesCount,
  totalCount,
  busy = false,
  busyMessage,
  onAcceptAndClose,
  onCloseWithoutAccept,
  onCancel,
}) => {
  const totalWord = totalCount === 1 ? 'clause' : 'clauses';
  const haveWord = trackChangesCount === 1 ? 'has' : 'have';

  return (
    <div
      className="aa-modal-backdrop"
      role="presentation"
      onClick={(event) => {
        if (!busy && event.target === event.currentTarget) onCancel();
      }}
    >
      <div
        className="aa-modal bcc-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="bcc-modal-title"
      >
        <div className="aa-modal-header">
          <div className="aa-modal-icon-wrap bcc-modal-icon-wrap">
            <Lock className="bcc-modal-icon" aria-hidden />
          </div>
          <div className="aa-modal-header-text">
            <h2 id="bcc-modal-title" className="aa-modal-title">
              Accept track changes before closing?
            </h2>
            <p className="aa-modal-subtitle">
              {trackChangesCount} of {totalCount} selected {totalWord} {haveWord} client requests
              with redlines / track changes.
            </p>
          </div>
          <button
            type="button"
            className="aa-modal-close"
            onClick={onCancel}
            disabled={busy}
            aria-label="Cancel"
          >
            <X size={16} aria-hidden />
          </button>
        </div>

        <p className="bcc-modal-body">
          Choose <strong>Accept and close</strong> to accept track changes in Word first, then lock
          all {totalCount} {totalWord}.
          {' '}
          Choose <strong>Close without accepting</strong> to lock all {totalCount} {totalWord}{' '}
          and leave redlines unchanged in the document.
        </p>

        {busy && busyMessage && (
          <div className="bcc-modal-busy" role="status" aria-live="polite">
            <span className="bcc-modal-busy-spinner" aria-hidden />
            <span>{busyMessage}</span>
          </div>
        )}

        <div className="bcc-modal-actions">
          <button
            type="button"
            className="bcc-modal-btn bcc-modal-btn--secondary"
            onClick={onCancel}
            disabled={busy}
          >
            Cancel
          </button>
          <button
            type="button"
            className="bcc-modal-btn bcc-modal-btn--secondary"
            onClick={onCloseWithoutAccept}
            disabled={busy}
          >
            Close without accepting ({totalCount})
          </button>
          <button
            type="button"
            className="bcc-modal-btn bcc-modal-btn--primary"
            onClick={onAcceptAndClose}
            disabled={busy}
          >
            Accept and close ({totalCount})
          </button>
        </div>
      </div>
    </div>
  );
};
